<template>
    <div>
        <div class="simple-form flex col-4">
            <div class="form-group center">
                <div class="form-label">
                    <label>源文件名</label>
                </div>
                <div class="form-value" title="shopDeviceImpRec.fileName">
                    <span>{{shopDeviceImpRec.fileName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>导入人</label>
                </div>
                <div class="form-value">
                    <span>{{shopDeviceImpRec.importerName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>导入时间</label>
                </div>
                <div class="form-value">
                    <span>{{shopDeviceImpRec.importTime}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>成功条数</label>
                </div>
                <div class="form-value">
                    <span style="color: green">{{shopDeviceImpRec.doneCount}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>失败条数</label>
                </div>
                <div class="form-value">
                    <span v-if="shopDeviceImpRec.errorCount != 0" style="color: red">{{shopDeviceImpRec.errorCount}}</span>
                    <span v-else>{{shopDeviceImpRec.errorCount}}</span>
                </div>
            </div>
        </div>
        <swb-query-sort-area :config="queryConfig" :queryHandler="queryHandler"></swb-query-sort-area>
        <div class="table-layout" style="overflow-x: auto;height: 520px;">
            <table class="custom-tbl" style="font-size:12px;">
                <thead class="head">
                <tr class="row">
                    <th width="70" class="align-right" style="padding-right:8px;">源件行号</th>
                    <th width="80">检查状态</th>
                    <th width="200">检查结果信息</th>
                    <th width="80">执行状态</th>
                    <th width="200">执行结果信息</th>
                    <th width="80" v-if="shopDeviceImpRec.updateFlag == false">入账状态</th>
                    <th width="200">提示信息</th>
                    <th v-if="viewFieldFlag('batchNo')" class="align-left" width="100">{{getFieldTitle('batchNo', '批次号')}}</th>
                    <th v-if="viewFieldFlag('tmpNo')" class="align-left" width="100">{{getFieldTitle('tmpNo', '系统编号')}}</th>
                    <th v-if="viewFieldFlag('innerCode')" class="align-left" width="100">{{getFieldTitle('innerCode', '资产编号')}}</th>
                    <th v-if="viewFieldFlag('assetTypeTitle')" width="100">{{getFieldTitle('assetTypeTitle', '管理方式')}}</th>
                    <!--<th class="align-left" width="100">资产编号</th>-->
                    <th v-if="viewFieldFlag('devcDefNo')" class="align-left" width="150">{{getFieldTitle('devcDefNo', '定义编码')}}</th>
                    <th class="align-left" width="200" v-if="viewFieldFlag('innerNo')">{{getFieldTitle('innerNo', '外部系统编号')}}</th>
                    <th class="align-left" width="200" v-if="viewFieldFlag('upc')">{{getFieldTitle('upc', '统一商品代码(UPC)')}}</th>
                    <th class="align-left" width="250" v-if="viewFieldFlag('name')">{{getFieldTitle('name', '名称')}}</th>
                    <th class="align-left" width="250" v-if="viewFieldFlag('title')">{{getFieldTitle('title', '描述全称')}}</th>
                    <th class="align-left" width="250" v-if="viewFieldFlag('retailerBizUnitName')">{{getFieldTitle('retailerBizUnitName', '业务单元')}}</th>
                    <th class="align-left" width="250" v-if="viewFieldFlag('retailerComName')">{{getFieldTitle('retailerComName', '所属部门')}}</th>
                    <th width="80" v-if="viewFieldFlag('initStartDate')">{{getFieldTitle('initStartDate', '启用日期')}}</th>
                    <th class="align-left" width="140" v-if="viewFieldFlag('assetKindName')">{{getFieldTitle('assetKindName', '财务类别名称')}}</th>
                    <th class="align-left" width="140" v-if="viewFieldFlag('assetKindCode')">{{getFieldTitle('assetKindCode', '财务类别编码')}}</th>
                    <th class="align-left" width="140" v-if="viewFieldFlag('assetNatureName')">{{getFieldTitle('assetNatureName')}}</th>
                    <th class="align-left" width="140" v-if="viewFieldFlag('deprSpecCode')">{{getFieldTitle('deprSpecCode', '折旧分摊规则编码')}}</th>
                    <th class="align-left" width="140" v-if="viewFieldFlag('innerDevcCatCode')">资产分类</th>
                    <th class="align-left" width="140" v-if="viewFieldFlag('innerDevcCatCode')">{{getFieldTitle('innerDevcCatCode', '资产分类编码')}}</th>
                    <th class="align-left" width="140" v-if="viewFieldFlag('innerDevcBrandCode')">资产品牌</th>
                    <th class="align-left" width="140" v-if="viewFieldFlag('innerDevcBrandCode')">{{getFieldTitle('innerDevcBrandCode', '资产品牌编码')}}</th>
                    <th class="align-left" width="140" v-if="viewFieldFlag('devcGroupFullName')">{{getFieldTitle('devcGroupFullName', '维保分组')}}</th>
                    <th class="align-left" width="140" v-if="viewFieldFlag('brandName')">{{getFieldTitle('brandName', '商品品牌')}}</th>
                    <th class="align-left" width="250" v-if="viewFieldFlag('model')">{{getFieldTitle('model', '型号')}}</th>
                    <th class="align-left" width="250" v-if="viewFieldFlag('fixedSpec')">{{getFieldTitle('fixedSpec', '规格')}}</th>
                    <!--<th class="align-left" width="200">规格编码</th>-->
                    <th class="align-left" width="150" v-if="viewFieldFlag('vendorCreditCode')">{{getFieldTitle('vendorCreditCode', '供商统一社会信用码')}}</th>
                    <th width="60" v-if="viewFieldFlag('inspectFlag')">{{getFieldTitle('inspectFlag', '检验设备')}}</th>
                    <th width="70" v-if="viewFieldFlag('patrolFlag')">{{getFieldTitle('patrolFlag', '需巡查设备')}}</th>
                    <th width="70" v-if="viewFieldFlag('setupFlag')">{{getFieldTitle('setupFlag', '需安装')}}</th>
                    <th width="70" v-if="viewFieldFlag('asmblFlag')">{{getFieldTitle('asmblFlag', '需组装')}}</th>
                    <th width="70" v-if="viewFieldFlag('maintFlag')">{{getFieldTitle('maintFlag', '需保养设备')}}</th>
                    <th width="70" v-if="viewFieldFlag('repairFlag')">{{getFieldTitle('repairFlag', '需维修设备')}}</th>
                    <th width="70" v-if="viewFieldFlag('splitible')">{{getFieldTitle('splitible', '可拆分')}}</th>
                    <!--<th width="70" v-if="!deviceFlag">未结算资产</th>-->
                    <th class="align-right" width="50" style="padding-right:8px;" v-if="viewFieldFlag('existQuanity')">
                        <span>{{getFieldTitle('existQuanity', '数量')}}</span>
                    </th>
                    <!--<th class="align-right" width="70" style="padding-right:8px;" v-if="!deviceFlag">不入账</th>-->
                    <!--<th class="align-right" width="70" style="padding-right:8px;" v-if="!deviceFlag">是否在账</th>-->
                    <th class="align-left" width="100" v-if="viewFieldFlag('theUnit')">{{getFieldTitle('theUnit', '单位')}}</th>
                    <th width="80" v-if="viewFieldFlag('receiveTime')">{{getFieldTitle('receiveTime', '收货日期')}}</th>
                    <th class="align-right" width="80" style="padding-right:8px;" v-if="viewFieldFlag('wrntPeriod')">
                        <span>{{getFieldTitle('wrntPeriod', '质保期(月)')}}</span>
                    </th>
                    <th width="70" v-if="viewFieldFlag('useMannerText')">{{getFieldTitle('useMannerText', '使用方式')}}</th>
                    <th width="70" v-if="viewFieldFlag('acctEnterWayText')">{{getFieldTitle('acctEnterWayText', '入账方式')}}</th>
                    <th class="align-right" width="80" style="padding-right:8px;" v-if="viewFieldFlag('orgWorth')">{{getFieldTitle('orgWorth', '原值(元)')}}</th>
                    <th class="align-right" width="70" style="padding-right:8px;" v-if="viewFieldFlag('rmnWorthRatio')">
                        <span>{{getFieldTitle('rmnWorthRatio', '残值率(%)')}}</span>
                    </th>
                    <th width="100" v-if="viewFieldFlag('fiscalInTime')">{{getFieldTitle('fiscalInTime', '入账日期')}}</th>
                    <th width="100" v-if="viewFieldFlag('buyDate')">{{getFieldTitle('buyDate', '购置日期')}}</th>
                    <th width="100" v-if="viewFieldFlag('onsetDate')">{{getFieldTitle('onsetDate', '折旧起算日期')}}</th>
                    <th class="align-right" width="100" style="padding-right:8px;" v-if="viewFieldFlag('aggtDeprWorth')">
                        <span>{{getFieldTitle('aggtDeprWorth', '累计折旧值(元)')}}</span>
                    </th>
                    <th width="100" v-if="viewFieldFlag('lastDeprMonth')">{{getFieldTitle('lastDeprMonth', '最后折旧月份')}}</th>
                    <th width="100" v-if="viewFieldFlag('durableLife')">{{getFieldTitle('durableLife', '使用年限(月)')}}</th>
                    <th width="100" v-if="viewFieldFlag('expectedLife')">{{getFieldTitle('expectedLife', '预计使用年限(月)')}}</th>
                    <th width="100" v-if="viewFieldFlag('sellerInnerCode')">{{getFieldTitle('sellerInnerCode', '卖家标识')}}</th>
                    <th width="100" v-if="viewFieldFlag('allotAcntMethod')">{{getFieldTitle('allotAcntMethod', '转移核算方式')}}</th>
                    <th width="100" v-if="viewFieldFlag('transWorthRatio')">{{getFieldTitle('transWorthRatio', '转移值比例(%)')}}</th>
                    <th width="100" v-if="viewFieldFlag('deprMethodName')">{{getFieldTitle('deprMethodName', '折旧算法')}}</th>
                    <th width="100" v-if="viewFieldFlag('cnt1stMonth')">{{getFieldTitle('cnt1stMonth', '首月计提')}}</th>
                    <!--<th width="100" v-if="!deviceFlag">折旧完毕</th>-->
                    <th width="100" v-if="viewFieldFlag('fiscalAbnormal')">{{getFieldTitle('fiscalAbnormal', '财务异常')}}</th>
                    <!--<th width="70">是否报废</th>-->
                    <th class="align-left" width="70" v-if="viewFieldFlag('respblDepartName')">{{getFieldTitle('respblDepartName', '责任部门')}}</th>
                    <th class="align-left" width="70" v-if="viewFieldFlag('departNo')">{{getFieldTitle('departNo', '责任部门编码')}}</th>
                    <th class="align-left" width="70" v-if="viewFieldFlag('respblStaffName')">{{getFieldTitle('respblStaffName', '责任人')}}</th>
                    <th class="align-left" width="70" v-if="viewFieldFlag('principalNo')">{{getFieldTitle('principalNo', '责任人编码')}}</th>
                    <th class="align-left" width="200" v-if="viewFieldFlag('devcParts')">{{getFieldTitle('devcParts', '设备部件')}}</th>
                    <th class="align-left" width="100" v-if="viewFieldFlag('memo')">{{getFieldTitle('memo', '备注')}}</th>
                    <th class="align-left" width="100" v-if="viewFieldFlag('memo1')">{{getFieldTitle('memo1', '备注1')}}</th>
                    <th class="align-left" width="100" v-if="viewFieldFlag('memo2')">{{getFieldTitle('memo2', '备注2')}}</th>
                    <th class="align-left" width="100" v-if="viewFieldFlag('memo3')">{{getFieldTitle('memo3', '备注3')}}</th>
                    <th class="align-left" width="100" v-if="viewFieldFlag('classifyTagName')">{{getFieldTitle('classifyTagName', '归类标签')}}</th>
                    <template v-for="field in devcCustFieldList">
                        <th class="align-left" width="100" v-if="viewFieldFlag('ext-' + field.name, true)">{{ '自定义-' + field.title }}</th>
                    </template>
                </tr>
                </thead>
                <tbody class="body">
                <tr class="row" v-for="shopDeviceImpItem in shopDeviceImpItemList">
                    <td class="align-right" style="padding-right:8px;color:#999;">{{shopDeviceImpItem.rowNo}}</td>
                    <td>
                        <span v-if="shopDeviceImpItem.checkState == -1" style="color: red">{{ checkStateMap[shopDeviceImpItem.checkState] }}</span>
                        <span v-else-if="shopDeviceImpItem.checkState == 1" style="color: green">{{ checkStateMap[shopDeviceImpItem.checkState] }}</span>
                        <span v-else>{{ checkStateMap[shopDeviceImpItem.checkState] }}</span>
                    </td>
                    <td width="100">{{shopDeviceImpItem.checkFailMsg || ''}}</td>
                    <td>
                        <span v-if="shopDeviceImpItem.execState == -1" style="color: red">{{ execStateMap[shopDeviceImpItem.execState] }}</span>
                        <span v-else-if="shopDeviceImpItem.execState == 1" style="color: green">{{ execStateMap[shopDeviceImpItem.execState] }}</span>
                        <span v-else>{{ execStateMap[shopDeviceImpItem.execState] }}</span>
                    </td>
                    <td width="100">{{shopDeviceImpItem.execFailMsg || ''}}</td>
                    <td v-if="shopDeviceImpRec.updateFlag == false">
                        <span v-if="shopDeviceImpItem.fiscalState == -1" style="color: red">{{ execStateMap[shopDeviceImpItem.fiscalState] }}</span>
                        <span v-else-if="shopDeviceImpItem.fiscalState == 1" style="color: green">{{ execStateMap[shopDeviceImpItem.fiscalState] }}</span>
                        <span v-else>{{ execStateMap[shopDeviceImpItem.fiscalState] }}</span>
                    </td>
                    <td width="100">{{shopDeviceImpItem.warnMsg || ''}}</td>
                    <td class="align-left" v-if="viewFieldFlag('batchNo')">{{shopDeviceImpItem.batchNo}}</td>

                    <td class="align-left" v-if="viewFieldFlag('tmpNo')">{{shopDeviceImpItem.tmpNo}}</td>
                    <td class="align-left" v-if="viewFieldFlag('innerCode')">{{shopDeviceImpItem.innerCode}}</td>
                    <td v-if="viewFieldFlag('assetTypeTitle')">{{assetTypeMap[shopDeviceImpItem.assetType]}}</td>
                    <td class="align-left" v-if="viewFieldFlag('devcDefNo')">{{shopDeviceImpItem.devcDefCode}}</td>
                    <td class="align-left" v-if="viewFieldFlag('innerNo')">{{shopDeviceImpItem.innerNo}}</td>
                    <td class="align-left" v-if="viewFieldFlag('upc')">{{shopDeviceImpItem.upc}}</td>
                    <td class="align-left" v-if="viewFieldFlag('name')">{{shopDeviceImpItem.devcName}}</td>
                    <td class="align-left" v-if="viewFieldFlag('title')">{{shopDeviceImpItem.devcTitle}}</td>
                    <td class="align-left" v-if="viewFieldFlag('retailerBizUnitName')">{{shopDeviceImpItem.bizUnitName}}</td>
                    <td class="align-left" v-if="viewFieldFlag('retailerComName')">{{shopDeviceImpItem.shopName}}</td>
                    <td v-if="viewFieldFlag('initStartDate')">{{shopDeviceImpItem.initStartDate}}</td>
                    <td class="align-left" v-if="viewFieldFlag('assetKindName')">{{shopDeviceImpItem.assetKindName}}</td>
                    <td class="align-left" v-if="viewFieldFlag('assetKindCode')">{{shopDeviceImpItem.assetKindCode}}</td>
                    <td class="align-left" v-if="viewFieldFlag('assetNatureName')">{{assetNatureMap[shopDeviceImpItem.assetNature]}}</td>
                    <td class="align-left" v-if="viewFieldFlag('deprSpecCode')">{{shopDeviceImpItem.deprSpecCode}}</td>
                    <td class="align-left" v-if="viewFieldFlag('innerDevcCatCode')">{{shopDeviceImpItem.innerDevcCatName}}</td>
                    <td class="align-left" v-if="viewFieldFlag('innerDevcCatCode')">{{shopDeviceImpItem.innerDevcCatCode}}</td>
                    <td class="align-left" v-if="viewFieldFlag('innerDevcBrandCode')">{{shopDeviceImpItem.innerDevcBrandName}}</td>
                    <td class="align-left" v-if="viewFieldFlag('innerDevcBrandCode')">{{shopDeviceImpItem.innerDevcBrandCode}}</td>
                    <td class="align-left" v-if="viewFieldFlag('devcGroupFullName')">{{shopDeviceImpItem.devcGroupFullName}}</td>
                    <td class="align-left" v-if="viewFieldFlag('brandName')">{{shopDeviceImpItem.brandName}}</td>
                    <td class="align-left" v-if="viewFieldFlag('model')">{{shopDeviceImpItem.model}}</td>
                    <td class="align-left" v-if="viewFieldFlag('fixedSpec')">{{shopDeviceImpItem.fixedSpec}}</td>
                    <!--<td class="align-left">{{shopDeviceImpItem.fixedSpecCode}}</td>-->
                    <td class="align-left" v-if="viewFieldFlag('vendorCreditCode')">{{shopDeviceImpItem.innerVendorNo}}</td>
                    <td v-if="viewFieldFlag('inspectFlag')"><span style="font-size: 20px">{{shopDeviceImpItem.inspectFlag ? '√' : ''}}</span></td>
                    <td v-if="viewFieldFlag('patrolFlag')"><span style="font-size: 20px">{{shopDeviceImpItem.patrolFlag ? '√' : ''}}</span></td>
                    <td v-if="viewFieldFlag('setupFlag')"><span style="font-size: 20px">{{shopDeviceImpItem.setupFlag ? '√' : ''}}</span></td>
                    <td v-if="viewFieldFlag('asmblFlag')"><span style="font-size: 20px">{{shopDeviceImpItem.asmblFlag ? '√' : ''}}</span></td>
                    <td v-if="viewFieldFlag('maintFlag')"><span style="font-size: 20px">{{shopDeviceImpItem.maintFlag ? '√' : ''}}</span></td>
                    <td v-if="viewFieldFlag('repairFlag')"><span style="font-size: 20px">{{shopDeviceImpItem.repairFlag ? '√' : ''}}</span></td>
                    <td v-if="viewFieldFlag('splitible')"><span style="font-size: 20px">{{shopDeviceImpItem.splitible ? '√' : ''}}</span></td>
                    <!--<td><span style="font-size: 20px" v-if="!deviceFlag">{{shopDeviceImpItem.outerUnsettled ? '√' : ''}}</span></td>-->
                    <td class="align-right" style="padding-right:8px;" v-if="viewFieldFlag('existQuanity')">{{shopDeviceImpItem.quantity}}</td>
                    <!--<td><span style="font-size: 20px" v-if="!deviceFlag">{{shopDeviceImpItem.fiscalIgnored ? '√' : ''}}</span></td>-->
                    <!--<td><span style="font-size: 20px" v-if="!deviceFlag">{{shopDeviceImpItem.fiscalAcctFlag ? '√' : ''}}</span></td>-->
                    <td class="align-left" v-if="viewFieldFlag('theUnit')">{{shopDeviceImpItem.theUnit}}</td>
                    <td v-if="viewFieldFlag('receiveTime')">{{shopDeviceImpItem.recvDate}}</td>
                    <td class="align-right" style="padding-right:8px;" v-if="viewFieldFlag('wrntPeriod')">{{shopDeviceImpItem.wrntPeriod}}</td>
                    <td v-if="viewFieldFlag('useMannerText')">{{useMannerMap[shopDeviceImpItem.useManner] || ''}}</td>
                    <td v-if="viewFieldFlag('acctEnterWayText')">{{acctEnterWayMap[shopDeviceImpItem.acctEnterWay]}}</td>
                    <td class="align-right" style="padding-right:8px;" v-if="viewFieldFlag('orgWorth')">{{shopDeviceImpItem.orgWorth}}</td>
                    <td class="align-right" style="padding-right:8px;" v-if="viewFieldFlag('rmnWorthRatio')">{{shopDeviceImpItem.rmnWorthRatio}}</td>
                    <td v-if="viewFieldFlag('fiscalInTime')">{{shopDeviceImpItem.fiscalInTime}}</td>
                    <td v-if="viewFieldFlag('buyDate')">{{shopDeviceImpItem.buyDate}}</td>
                    <td v-if="viewFieldFlag('onsetDate')">{{shopDeviceImpItem.onsetDate}}</td>
                    <td class="align-right" style="padding-right:8px;" v-if="viewFieldFlag('aggtDeprWorth')">{{shopDeviceImpItem.aggtDeprWorth}}</td>
                    <td v-if="viewFieldFlag('lastDeprMonth')">{{shopDeviceImpItem.lastDeprMonth}}</td>
                    <td v-if="viewFieldFlag('durableLife')">{{shopDeviceImpItem.durableLife}}</td>
                    <td v-if="viewFieldFlag('expectedLife')">{{shopDeviceImpItem.expectedLife}}</td>
                    <td v-if="viewFieldFlag('sellerInnerCode')">{{shopDeviceImpItem.sellerInnerCode}}</td>

                    <td v-if="viewFieldFlag('allotAcntMethod')">{{shopDeviceImpItem.allotAcntMethod || ''}}</td>
                    <td v-if="viewFieldFlag('transWorthRatio')">{{shopDeviceImpItem.transWorthRatio || 0.00}}</td>
                    <td v-if="viewFieldFlag('deprMethodName')">{{shopDeviceImpItem.deprMethodName || ''}}</td>
                    <td v-if="viewFieldFlag('cnt1stMonth')">{{shopDeviceImpItem.cnt1stMonth ? '是' : '否'}}</td>
                    <!--<td v-if="!deviceFlag">{{shopDeviceImpItem.deprOver ? '是' : '否'}}</td>-->
                    <td v-if="viewFieldFlag('fiscalAbnormal')">{{shopDeviceImpItem.fiscalAbnormal == null ? '' : (shopDeviceImpItem.fiscalAbnormal ? '是' : '否')}}</td>

                    <!--<td class="align-left">{{shopDeviceImpItem.scrapped ? '√' : ''}}</td>-->
                    <td class="align-left" v-if="viewFieldFlag('respblDepartName')">{{shopDeviceImpItem.departName}}</td>
                    <td class="align-left" v-if="viewFieldFlag('departNo')">{{shopDeviceImpItem.departNo}}</td>
                    <td class="align-left" v-if="viewFieldFlag('respblStaffName')">{{shopDeviceImpItem.principalName}}</td>
                    <td class="align-left" v-if="viewFieldFlag('principalNo')">{{shopDeviceImpItem.principalNo}}</td>
                    <td class="align-left" v-if="viewFieldFlag('devcParts')">{{shopDeviceImpItem.devcParts}}</td>
                    <td class="align-left" v-if="viewFieldFlag('memo')">{{shopDeviceImpItem.memo}}</td>
                    <td class="align-left" v-if="viewFieldFlag('memo1')">{{shopDeviceImpItem.memo1}}</td>
                    <td class="align-left" v-if="viewFieldFlag('memo2')">{{shopDeviceImpItem.memo2}}</td>
                    <td class="align-left" v-if="viewFieldFlag('memo3')">{{shopDeviceImpItem.memo3}}</td>
                    <td class="align-left" v-if="viewFieldFlag('classifyTagName')">{{shopDeviceImpItem.classifyTagName}}</td>
                    <template v-for="field in devcCustFieldList">
                        <td class="align-left" v-if="viewFieldFlag('ext-' + field.name, true)">
                            <span>{{ field.type == 'Boolean' ? (shopDeviceImpItem.custFiled[field.name] ? '是' : '否') : shopDeviceImpItem.custFiled[field.name]}}</span>
                        </td>
                    </template>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="pagination-layout">
            <el-pagination background v-if="totalCount > 0" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="prev, pager, next, jumper, sizes, total"></el-pagination>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import { getDefaultPageSizes } from '../../../src/app.conf'
    import { checkUserActionPerm } from '../index'
    import { getMerchantBizParam } from '../asset/assetMain'

    import userApi from '../../api/user'
    import devcApi from '../../api/devc'
    import merchtComnApi from '../../api/merchtComn'
    import comnApi from '../../api/comn'

    let searchConfigData = {
        "queryFields": [{
            "type": "Select",
            "label": "检查状态",
            "valueType": "Integer",
            "code": "checkState",
            "dataList": [{
                "value": 0,
                "label": "未核对"
            }, {
                "value": 2,
                "label": "核对中"
            }, {
                "value": 1,
                "label": "核对有效"
            }, {
                "value": -1,
                "label": "核对无效"
            }],
            "basic": true
        }, {
            "type": "Select",
            "label": "执行状态",
            "valueType": "Integer",
            "code": "execState",
            "dataList": [{
                "value": 0,
                "label": "未执行"
            }, {
                "value": 2,
                "label": "执行中"
            }, {
                "value": 1,
                "label": "成功"
            }, {
                "value": -1,
                "label": "执行失败"
            }],
            "basic": true
        }, {
            "type": "Select",
            "label": "入账状态",
            "valueType": "Integer",
            "code": "fiscalState",
            "dataList": [{
                "value": 0,
                "label": "未执行"
            }, {
                "value": 2,
                "label": "执行中"
            }, {
                "value": 1,
                "label": "成功"
            }, {
                "value": -1,
                "label": "执行失败"
            }],
            "basic": true
        }],
        "sortFields": []
    };

    export default {
        name: 'swb-shop-devc-imp-item-list',
        desc: '机构设备导入记录详细列表',
        props: ['recId', 'selfThis', 'deviceFlag'],
        data: function () {
            return {
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                queryConfig: null,
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                shopDeviceImpRec: {},
                shopDeviceImpItemList: [],
                acctEnterWayMap: getEnumMap('acctEnterWay', 'value2text'),
                deviceUseStateMap: getEnumMap('deviceUseState', 'value2text'),
                devcVoucherTypeEnumMap: getEnumMap("devcVoucherType", "value2text"),
                assetTypeMap: getEnumMap("assetType", "value2text"),
                useMannerMap: getEnumMap("devcUseManner", "value2text"),
                checkStateMap: getEnumMap("checkState", "value2text"),
                execStateMap: getEnumMap("execState", "value2text"),
                assetNatureMap: getEnumMap("assetNature", "value2text"),
                //
                scopeId: null,
                devcCustFieldList: [],
                fieldMap: {},
                custFileds: []
            }
        },
        created: function () {
            let self = this;
            self.queryConfig = searchConfigData;
            this.pageSize = this.pageSizes.first();
            this.getShopDeviceImpRecById(this.recId);
            //
            this.getCurrentUserInfo();
            this.getDevcCustFieldList();
        },
        methods: {
            viewFieldFlag(name, ignoreBase){
                let custFileds = this.custFileds;
                let custFlag = true;
                if(!Utils.isNoB(custFileds) && custFileds.length > 0) {
                    custFlag = this.custFileds.indexOf(name) > -1;
                }
                //
                let baseFlag = this.fieldMap[name] != null;
                if(Utils.isTrue(ignoreBase)) {
                    baseFlag = true;
                }
                return custFlag && baseFlag;
            },
            getFieldTitle(name, defTitle){
                return this.fieldMap[name] != null ? this.fieldMap[name].title : defTitle;
            },
            getComnXportConfByUsage(usage){
                let self = this;
                let theLoading = MsgBox.loading();
                comnApi.getComnXportConfByUsage({usage: usage}, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        let comnXportConf = result.data;
                        //
                        let sheetList = comnXportConf.sheetList;
                        sheetList.forEach(function (sheet) {
                            if(sheet.name == '店铺资产列表') {
                                let fieldList = sheet.fieldList;
                                self.fieldMap = fieldList.toMap('name');
                            }
                        });
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getDevcCustFieldList(){
                let self = this;
                let theLoading = MsgBox.loading();
                merchtComnApi.getDevcCustFieldList({}, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        let devcCustFieldList = result.data;
                        self.devcCustFieldList = devcCustFieldList;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            checkActionPerm(action) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, null);
            },
            getCurrentUserInfo: function () {
                let self = this;
                userApi.getUserInfoByContext({}, function (result, jqXhr) {
                    if(result.type == 'info') {
                        let data = result.data;
                        self.scopeId = data.scopeEntity.scopeId;
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            getShopDeviceImpRecById: function (recId) {
                let self = this;
                devcApi.getShopDeviceImpRecById(recId, function (result) {
                    if(result.type == 'info') {
                        let shopDeviceImpRec = result.data;
                        if(!Utils.isNoB(shopDeviceImpRec.tplConfig)) {
                            let custFiledMap = JSON.decode(shopDeviceImpRec.tplConfig);
                            self.custFileds = custFiledMap['店铺资产列表'];
                        }
                        self.shopDeviceImpRec = shopDeviceImpRec;
                        self.getComnXportConfByUsage(shopDeviceImpRec.tplUsage);
                        self.getShopDeviceImpItemPageListByFilter();
                    } else {
                        self.$message.warning(result.message);
                    }
                });
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.getShopDeviceImpItemPageListByFilter();
            },
            handleSizeChange: function (val) {
                this.pageSize = val;
                this.handlePageChange(1);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getShopDeviceImpItemPageListByFilter();
            },
            getShopDeviceImpItemPageListByFilter(){
                let self = this;
                let shopDeviceImpRec = this.shopDeviceImpRec;
                //
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.recId = shopDeviceImpRec.id;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                devcApi.getShopDeviceImpItemPageListByFilter(postData, function (result) {
                    if(result.type == 'info') {
                        let shopDeviceImpItemList = result.data.rows;
                        shopDeviceImpItemList.forEach(function (item) {
                            let custFiled = {};
                            if(item.custJson != null && item.custJson != '') {
                                custFiled = JSON.decode(item.custJson);
                            }
                            item.custFiled = custFiled;
                        });
                        self.shopDeviceImpItemList = shopDeviceImpItemList;
                        self.totalCount = result.data.pagination.totalCount;
                    } else {
                        self.$message.warning(result.message);
                    }
                });
            },
        }
    }
</script>
<style>
    .el-dialog__body {
        padding-top: 0 !important;
    }
</style>



// WEBPACK FOOTER //
// src/compo/devc/ShopDevcImpItemList.vue